import { useMutation } from '@tanstack/react-query';

// Services
import { postManagerGeneric } from './genericUrlService';

/**
 * Generic mutation to call any endpoint
 * @param {string} url - The URL to call
 * @param {import('@tanstack/react-query').UseMutationOptions<any, Error, any, any>} [options = {}] - The mutation options
 * @returns {import('@tanstack/react-query').UseMutationResult<any, Error, any, any>} The generic mutation
 */
export const useManagerGenericMutation = (url, options = {}) => useMutation({
  mutationFn: (data) => postManagerGeneric(url, data),
  ...options,
});
